<template>
	<form class="w-100" @submit.prevent="submit">
		<div class="row">
			<div class="col-12 text-left">
				<button v-if="id !== 'new'" @click="del" type="button" class="btn btn-danger">
					حذف اشتراک
					<i class="fas fa-trash" />
				</button>
				<button type="submit" class="btn btn-success mr-2">
					<span v-if="id !== 'new'">
						بروررسانی اشتراک
						<i class="far fa-save" />
					</span>
					<span v-else>
						ذخیره اشتراک جدید
						<i class="fas fa-plus" />
					</span>
				</button>
				<hr>
			</div>
			<div v-if="id === 'new' || (id !== 'new' && Object.keys(item).length > 0)" class="col-12">
				<div class="row">
					<div v-if="id !== 'new'" class="col-12 col-sm-6 col-lg-3">
						<StatsCard>
							<div class="icon-big text-center icon-info" slot="header">
								<i class="fas fa-unlock-alt" />
							</div>
							<div class="text-center" slot="content">
								<p>تاریخ ایجاد</p>
								{{ $dateTimeFormat(item.created_at) }}
							</div>
						</StatsCard>
					</div>
					<div class="col-12">
						<card class="card" title="اطلاعات پایه">
							<div>
								<div class="form-row">
									<div class="col-12 col-lg-4 mb-3">
										<div class="form-group text-right">
											<label for="title">عنوان</label>
											<input id="title" type="text" class="form-control" placeholder="عنوان"
												v-model="item.title">
										</div>
									</div>
									<div class="col-12 col-lg-4 mb-3">
										<div class="form-group text-right">
											<label for="days_count">مدت زمان(روز)</label>
											<input id="days_count" type="number" class="form-control"
												placeholder="مدت زمان به روز مثلا 30" v-model.number="item.days_count">
										</div>
									</div>
									<div class="col-12 col-lg-4 mb-3">
										<div class="form-group text-right">
											<label for="price">قیمت</label>
											<input id="price" type="text" class="form-control" placeholder="قیمت"
												:value="$priceMask(item.price)"
												@input="item.price = $normalNum($event.target.value)" />
										</div>
									</div>
									<div class="col-12 col-lg-4 mb-3">
										<div class="form-group text-right">
											<label for="currency">واحد پول</label>
											<appCurrencySelect id="currency" v-model="item.currency" />
										</div>
									</div>
									<div class="col-12 col-lg-4 mb-3">
										<div class="form-group text-right">
											<label for="discount_percent">درصد تخفیف( مثلا 10 و اگر ندارید 0 وارد
												کنید)</label>
											<input required id="discount_percent" type="number" class="form-control"
												placeholder="درصد تخفیف" v-model.number="item.discount_percent" />
										</div>
									</div>
									<div class="col-12 col-lg-4 mb-3">
										<div class="form-group text-right">
											<label for="tax_pct">درصد مالیات(مثلا 9 و اگر ندارد 0 وارد
												کنید)</label>
											<input required id="tax_pct" type="number" class="form-control"
												placeholder="درصد مالیات" v-model.number="item.tax_pct" />
										</div>
									</div>
									<div class="col-12 col-lg-4 mb-3">
										<div class="form-group text-right">
											<label for="order">ترتیب</label>
											<input id="order" type="number" class="form-control" placeholder="ترتیب"
												v-model.number="item.order">
										</div>
									</div>
									<div class="col-12 col-xl-4 mb-3">
										<div class="form-group text-right">
											<label for="enable">فعال</label>
											<fv-switch id="enable" class="form-control d-block" placeholder="فعال"
												v-model="item.enabled" />
										</div>
									</div>
									<div class="col-12 col-xl-4 mb-3">
										<div class="form-group text-right">
											<label for="enable">قابلیت نمایش در صفحه اشتراک</label>
											<fv-switch id="enable" class="form-control d-block"
												placeholder="قابلیت نمایش در صفحه اشتراک" v-model="item.view" />
										</div>
									</div>
									<div class="clearfix" />
								</div>
							</div>
						</card>
					</div>
				</div>
			</div>
		</div>
	</form>
</template>
<script>
import Modela from 'modela'
import { mapActions } from "vuex"
import planModel from "../../models/plan";
import { StatsCard } from "@/components/index";
import appCurrencySelect from "../../components/appCurrencySelect";

export default {
	name: 'plan_edit',
	components: { StatsCard },
	data() {
		const { params } = this.$route
		const { id } = params
		return {
			...mapActions('main', [
				'crud'
			]),
			id,
			item: {},
			creators: []
		}
	},
	computed: {},
	components: {
		appCurrencySelect,
	},
	methods: {
		async getData() {
			try {
				this.$store.commit('main/SET', { key: 'loading', value: true })
				const plan = await this.crud({
					action: 'get',
					section: 'plans',
					id: this.id,
					showError: true
				})

				const result = plan.data
				let item = new Modela(planModel)
				item = item.$clean()
				item = item.$set(result)
				this.item = item.$clean().$export()

			} catch (e) {
				console.log(e)
			} finally {
				this.$store.commit('main/SET', { key: 'loading', value: false })
			}
		},
		async post() {
			try {
				this.$store.commit('main/SET', { key: 'loading', value: true })
				const newPlan = await this.crud({
					action: 'post',
					section: 'plans',
					data: this.item,
					showError: true
				})
				await this.$successAlert()
				this.$router.go(-1)
				// await this.$router.push({name: 'plans'})
			} catch (e) {
				// console.log(e)
			} finally {
				this.$store.commit('main/SET', { key: 'loading', value: false })
			}

		},
		async put() {
			try {
				this.$store.commit('main/SET', { key: 'loading', value: true })
				const updatePlan = await this.crud({
					action: 'put',
					section: 'plans',
					id: this.id,
					data: this.item,
					showError: true
				})
				this.$successAlert()
				this.$router.go(-1)
				// await this.$router.push({name: 'plans'})
			} catch (e) {
				// console.log(e)
			} finally {
				this.$store.commit('main/SET', { key: 'loading', value: false })
			}

		},
		async del() {
			if (!await this.$confirmAlert())
				return false
			try {
				this.$store.commit('main/SET', { key: 'loading', value: true })
				const deleted = await this.crud({
					action: 'delete',
					section: 'plans',
					id: this.id,
					showError: true
				})
				await this.$successAlert()
				// await this.$router.push({name: 'plans'})
				this.$router.go(-1)
			} catch (e) {
				// console.log(e)
			} finally {
				this.$store.commit('main/SET', { key: 'loading', value: false })
			}
		},
		async submit() {
			if (this.id !== 'new')
				this.put()
			else
				this.post()
		},
	},
	async created() {
		if (this.id !== 'new')
			await this.getData()
		else {
			let item = new Modela(planModel)
			this.item = item.$clean().$export()
		}

		setTimeout(() => {
			console.log("eshterak", this.item)
		}, 3000);
	}
};
</script>
<style></style>
